import { Button, Checkbox, Modal, ModalBody, ModalCloseButton, ModalContent, ModalHeader, ModalOverlay, Table, TableContainer, Thead, Tr, Th, Tbody, useDisclosure, filter } from "@chakra-ui/react";
import { deleteFinanza, downloadTemplate, obtenerCategorias, obtenerFinanzasRegistro, postRegistroFinanza, postRegistroFinanzaMultiple } from "../../services/obtenerFinanzas";
import { useEffect, useState } from "react";
import Papa from 'papaparse';
import Select from 'react-select';
import "./financeManagement.css";
import { useDidUpdateEffect } from "../../util/util";
import { buscarTitular } from "../../services/buscarTitular";
import Pagination from "../util/pagination/pagination";
import { useTranslation } from "react-i18next";
import { formatToMXN } from "../util/util";

// Estilos personalizados para La Campiña
const customStyles = {
    // Estilos para el Select y CreatableSelect
    select: {
        control: (provided, state) => ({
            ...provided,
            border: "1px solid #ddd",
            borderRadius: "5px",
            boxShadow: state.isFocused ? "0 0 0 2px #e06c00" : null,
            "&:hover": {
                borderColor: "#e06c00",
            },
        }),
        option: (provided, state) => ({
            ...provided,
            backgroundColor: state.isSelected ? "#e06c00" : state.isFocused ? "#f8f9fa" : null,
            color: state.isSelected ? "white" : "#333",
            "&:hover": {
                backgroundColor: "#f8f9fa",
                color: "#333",
            },
        }),
        multiValue: (provided) => ({
            ...provided,
            backgroundColor: "#f8f9fa",
        }),
        multiValueLabel: (provided) => ({
            ...provided,
            color: "#333",
        }),
        multiValueRemove: (provided) => ({
            ...provided,
            color: "#666",
            "&:hover": {
                backgroundColor: "#e06c00",
                color: "white",
            },
        }),
    },
    // Estilos para botones
    button: {
        primary: {
            backgroundColor: "#e06c00",
            color: "white",
            _hover: {
                backgroundColor: "#c45a00",
            },
        },
        danger: {
            backgroundColor: "#e63946",
            color: "white",
            _hover: {
                backgroundColor: "#c62a37",
            },
        },
    },
    // Estilos para modales
    modal: {
        headerBg: "#e06c00",
        headerColor: "white",
    }
};

export const FinanceManagement = () => {

    const { t } = useTranslation();

    // FINANZA RECORD VARIABLES
    const [finanzaRecords, setFinanzaRecords] = useState([]);
    const [searchFinanzaRecord, setSearchFinanzaRecord] = useState('');
    const [pageFinanzaRecord, setPageFinanzaRecord] = useState(1);
    const [totalPagesFinanzaRecord, setTotalPagesFinanzaRecord] = useState(1);
    const [filterByTitular, setFilterByTitular] = useState(null);
    const [filterByCategoria, setFilterByCategoria] = useState(null);
    const [filterStartDate, setFilterStartDate] = useState("");
    const [filterEndDate, setFilterEndDate] = useState("");

    const [csvFile, setCsvFile] = useState(null);
    const [loadingCSV, setLoadingCSV] = useState(false);

    //////////////////////////////////////////

    // FINANZA SELECT SEARCH VARIABLES
    const [finanzas, setFinanzas] = useState([]);
    const [searchFinanza, setSearchFinanza] = useState('');
    const [page, setPage] = useState(1);
    const [totalPages, setTotalPages] = useState(1);

    //////////////////////////////////////////

    // TITULARES SELECT SEARCH VARIABLES
    const [titulares, setTitulares] = useState([]);
    const [searchTitular, setSearchTitular] = useState('');
    const [pageTitular, setPageTitular] = useState(1);
    const [totalPagesTitular, setTotalPagesTitular] = useState(1);

    //////////////////////////////////////////


    const [categorias, setCategorias] = useState([]);

    const [idFinanza, setIdFinanza] = useState(null);
    const [idTitular, setIdTitular] = useState(null);
    const [monto, setMonto] = useState('');
    const [fecha, setFecha] = useState('');
    const [global, setGlobal] = useState(false);

    const [loading, setLoading] = useState(false);

    


    const {
        isOpen: isOpenForm,
        onOpen: onOpenForm,
        onClose: onCloseForm,
    } = useDisclosure();

    // FINANCE MODAL VARIABLES
    const {
        isOpen: isOpenFinanceModal,
        onOpen: onOpenFinanceModal,
        onClose: onCloseFinanceModal,
    } = useDisclosure();

    const {
        isOpen: isOpenBulkModal,
        onOpen: onOpenBulkModal,
        onClose: onCloseBulkModal,
    } = useDisclosure();

    const [financeName, setFinanceName] = useState('');
    const [financeCategory, setFinanceCategory] = useState(null);
    const [financeDescription, setFinanceDescription] = useState('');

    const [deleteReg, setDeleteReg] = useState(null);

    const requestFinanzas = async (search, page) => {
        // try {
        //     const response = await obtenerFinanzas(search ? search : null, page ? page : null);
        //     if (response.status === 200) {
        //         console.log("RESPONSE", response.data);
        //         const formatedFinanzas = response.data.finanzas.map((finanza) => {
        //             return {
        //                 value: finanza.id,
        //                 label: finanza.nombre,
        //             }
        //         })
        //         if(page === 1){
        //             setFinanzas(formatedFinanzas);
        //         }
        //         else{
        //             setFinanzas([...finanzas, ...formatedFinanzas]);
        //         }
        //         setTotalPages(response.data.totalPages);
        //     }
        // }catch (error) {
        //     console.log(error);
        // }
    }

    const requestDeleteFinanzaRecord = async (id) => {
        try {
            const response = await deleteFinanza(id);
            if (response.status === 200) {
                requestFinanzaRecords();
            }
        }catch (error) {
            console.log(error);
        }finally{
            setDeleteReg(null);
        }
    }

    const requestTitular = async (search, page) => {
        try {
            const response = await buscarTitular(search ? search : null, page ? page : null);
            if (response.status === 200) {
                const formatedTitulares = response.data.titulares.map((titular) => {
                    return {
                        value: titular.id,
                        label: `${titular.nombre} ${titular.apellidos}`
                    }
                })
                setTitulares(pageTitular === 1 ? formatedTitulares : [...titulares, ...formatedTitulares]);
                setTotalPagesTitular(response.data.totalPages);
            }
        }catch (error) {
            console.log(error);
        }
    }

    const requestCategories = async () => {
        try {
            const response = await obtenerCategorias();
            if (response.status === 200) {
                setCategorias(response.data.categorias);
            }
        }catch (error) {
            console.log(error);
        }
    }

    const requestCreateFinance = async () => {
        // try {
        //     const response = await postFinanza({
        //         idCategoriaFinanza: financeCategory.value,
        //         nombre: financeName,
        //         descripcion: financeDescription,
        //     });
        //     if (response.status === 200) {
        //         requestFinanzas(response.data.nombre, page);
        //         setIdFinanza({
        //             value: response.data.id,
        //             label: response.data.nombre,
        //         });
        //         onCloseFinanceModal();
        //     }
        // }catch (error) {
        //     console.log(error);
        // }
    }

    // useEffect(() => {
    //     console.log("DATE", fecha)
    // }, [fecha])

    const requestCreateFinanceRecord = async () => {
        if(!financeCategory || !idTitular || !monto || !fecha){
            return;
        }
        setLoading(true);
        try{
            const data = {
                idTitular: idTitular.value,
                idCategoria: financeCategory.value,
                monto: monto,
                fecha: (new Date(fecha)).toISOString(),
                global
            }
            const response = await postRegistroFinanza(data)
            if(pageFinanzaRecord === 1){
                requestFinanzaRecords();
            }else{
                setPageFinanzaRecord(1);
            }
            onCloseForm();
            setIdTitular(null);
            setFinanceCategory(null);
            setMonto('');
            setFecha('');
            setGlobal(false);
        }
        catch(error){
            console.log(error)
        } finally {
            setLoading(false);
        }
    }

    const processBulkFinanceRecords = async () => {
        if (!csvFile) {
            alert(t("PLEASE_UPLOAD_CSV_FILE"));
            return;
        }

        setLoading(true);
        
        try {
            // Parse the CSV file
            const parsedData = await new Promise((resolve, reject) => {
                Papa.parse(csvFile, {
                    header: true,
                    skipEmptyLines: true,
                    complete: (results) => resolve(results.data),
                    error: (error) => reject(error),
                });
            });

            const validCategories = categorias.map(categoria => categoria.nombre);
            console.log("Valid Categories", validCategories);
    
            // Validate and transform the data
            const validRecords = parsedData.map((record, index) => {
                const { CorreoTitular, Categoría, Monto, fecha } = record;
    
                // Validate required fields
                if (!CorreoTitular) {
                    throw new Error(`Missing "Correo Titular" in row ${index + 2}`);
                }
                if (!Categoría) {
                    throw new Error(`Missing "Categoría" in row ${index + 2}`);
                }
                if (!Monto) {
                    throw new Error(`Missing "Monto" in row ${index + 2}`);
                }
                if (!fecha) {
                    throw new Error(`Missing "fecha" in row ${index + 2}`);
                }
    
                // Validate numeric fields
                const monto = parseFloat(Monto);
                if (isNaN(monto) || monto <= 0) {
                    throw new Error(`Invalid "Monto" value in row ${index + 2}: "${Monto}"`);
                }
    
                // Validate date format (YYYY-MM-DD)
                const dateRegex = /^\d{4}-\d{2}-\d{2}$/;
                if (!dateRegex.test(fecha)) {
                    throw new Error(`Invalid "fecha" format in row ${index + 2}: "${fecha}". Expected format: YYYY-MM-DD`);
                }

                const isValidCategory = validCategories.some(
                    (validCategory) => validCategory.toLowerCase() === Categoría.toLowerCase()
                );
                if (!isValidCategory) {
                    throw new Error(`Unknown "Categoría" in row ${index + 2}: "${Categoría}"`);
                }
    
                // Transform the record into the required format
                return {
                    correoTitular: CorreoTitular,
                    categoria: Categoría,
                    monto,
                    fecha,
                };
            });
    
            // Send the valid records to the API
            const response = await postRegistroFinanzaMultiple({registros: validRecords});
            if (response.status === 200) {
                console.log('Bulk finance records successfully processed.');
                // Optionally, refresh the records or update the UI
                requestFinanzaRecords();
                onCloseBulkModal(); // Close the modal after processing
            } else {
                console.error('Error processing bulk records:', response.data);
                throw new Error(`Failed to process bulk records: ${response.data.message ? response.data.message : 'Unknown error'}`);
            }
        } catch (error) {
            console.error('Error processing CSV file:', error.message);
            alert(`Error: ${error.message}`); // Notify the user about the error
        } finally {
            setLoading(false);
            setCsvFile(null); // Clear the file input after processing
        }
    };

    const downloadFile = async () => {
        try {
            const response = await downloadTemplate();

            const url = window.URL.createObjectURL(response.data); // Create a URL for the Blob
            const link = document.createElement('a'); // Create a temporary link element
            link.href = url;
            link.download = 'BulkTemplate.csv'; // Set the file name
            document.body.appendChild(link);
            link.click(); // Trigger the download
            link.remove(); // Clean up the link element
        } catch (error) {
            console.log(error)
        }
    };

    const requestFullFinanzaRecords = async () => {
        const response = await obtenerFinanzasRegistro({
            search: searchFinanzaRecord,
            page: pageFinanzaRecord,
            limit: 10,
            idUser: filterByTitular ? filterByTitular.value : null,
            startDate: filterStartDate ? (new Date(filterStartDate)).toISOString() : null,
            endDate: filterEndDate ? (new Date(filterEndDate)).toISOString() : null,
            category: filterByCategoria ? filterByCategoria.value : null,
            full: true,
        })
        return response;
    }

    const downloadFinancialData = async () => {
        setLoadingCSV(true);
        try {
            // Fetch all financial records
            const response = await requestFullFinanzaRecords();
    
            if (response.status !== 200) {
                throw new Error(t("ERROR_FETCHING_FINANCIAL_DATA"));
            }
    
            // Extract and format the data
            const formattedData = response.data.finanzaRegistros.map((record) => ({
                nombre: record.titular ? record.titular.nombre : 'Registro Global',
                apellidos: record.titular ? record.titular.apellidos : '',
                correo: record.titular ? record.titular.correo : '',
                membresía: record.titular ? record.titular.membresia : '',
                categoría: record.categoria ? record.categoria.nombre : 'N/A',
                tipo: record.categoria ? record.categoria.TipoMovimiento : 'N/A',
                monto: record.monto,
                fecha: record.fecha ? record.fecha.split("T")[0] : 'N/A',
            }));
    
            // Convert the data to CSV format
            const csv = Papa.unparse(formattedData);
    
            // Create a Blob and trigger the download
            const blob = new Blob([csv], { type: "text/csv;charset=utf-8;" });
            const url = window.URL.createObjectURL(blob);
            const link = document.createElement("a");
            link.href = url;
            link.download = "FinancialData.csv"; // Set the file name
            document.body.appendChild(link);
            link.click();
            link.remove();
        } catch (error) {
            console.error("Error downloading financial data:", error);
            alert(t("ERROR_DOWNLOADING_CSV")); // Notify the user about the error
        } finally {
            setLoadingCSV(false);
        }
    };


    const requestFinanzaRecords = async () => {
        const startDate = filterStartDate ? (new Date(filterStartDate)).toISOString() : null;
        let endDate = filterEndDate ? (new Date(filterEndDate)).toISOString() : null;
        if(endDate){
            endDate = new Date(`${endDate.split('T')[0]}T23:59:59`); // Set time to end of the day
            endDate = endDate.toISOString();
        }

        const response = await obtenerFinanzasRegistro({
            search: searchFinanzaRecord,
            page: pageFinanzaRecord,
            limit: 10,
            idUser: filterByTitular ? filterByTitular.value : null,
            startDate,
            endDate,
            category: filterByCategoria ? filterByCategoria.value : null,
        })
        if(response.status === 200){
            setFinanzaRecords(response.data.finanzaRegistros);
            setTotalPagesFinanzaRecord(response.data.totalPages);
        }
    }

    


    const handleCreateFinance = async (inputName) => {
        setFinanceName(inputName);
        setFinanceCategory(null);
        setFinanceDescription('');
        onOpenFinanceModal();
    }

    useEffect(() => {
        requestCategories();
    }, []);

    useEffect(() => {
        requestFinanzaRecords();
    }, [pageFinanzaRecord]);

    useEffect(() => {
        if(pageFinanzaRecord === 1){
            requestFinanzaRecords();
        }else{
            setPageFinanzaRecord(1);
        }
    }, [filterByTitular, filterByCategoria])

    useEffect(() => {
        if(pageFinanzaRecord === 1){
            requestFinanzaRecords();
        }else{
            setPageFinanzaRecord(1);
        }
    }, [filterStartDate, filterEndDate])

    useDidUpdateEffect(() => {
        const delayFunction = setTimeout(() => {
            if(pageFinanzaRecord !== 1){
                setPageFinanzaRecord(1)
            }else{
                requestFinanzaRecords();
            }
        }
        , 500)
        return () => clearTimeout(delayFunction)
    }, [searchFinanzaRecord])


    useEffect(() => {
        setPage(1);
    }, [searchFinanza]);

    useEffect(() => {
        requestFinanzas(searchFinanza, page);
    }, [page]);

    useDidUpdateEffect(() => {
        const delayFunction = setTimeout(() => {
            if(page !== 1){
                setPage(1)
            }else{
                requestFinanzas(searchFinanza, page);
            }
        }, 500)
        return () => clearTimeout(delayFunction)
    }, [searchFinanza])

    useEffect(() => {
        setPageTitular(1);
    }, [searchTitular]);

    useEffect(() => {
        requestTitular(searchTitular, pageTitular);
    }, [pageTitular]);

    useDidUpdateEffect(() => {
        const delayFunction = setTimeout(() => {
            if(pageTitular !== 1){
                setPageTitular(1)
            }else{
                requestTitular(searchTitular, pageTitular);
            }
        }, 500)
        return () => clearTimeout(delayFunction)
    }, [searchTitular])

    useEffect(() => {
        setSearchTitular('');
    }, [isOpenForm])

    
    const renderBulkModal = () => {
        return(
            <Modal isOpen={isOpenBulkModal} onClose={onCloseBulkModal} size={'xl'}>
                <ModalOverlay />
                <ModalContent>
                    <ModalHeader style={{ backgroundColor: customStyles.modal.headerBg, color: customStyles.modal.headerColor }}>
                        {t('BULK_FINANCE_RECORD')}
                    </ModalHeader>
                    <ModalCloseButton color="white" />
                    <ModalBody className="campina-modal-body">
                        <div className="form-group">
                            <label>{t('UPLOAD_CSV')}</label>
                            <input 
                                type="file" 
                                accept=".csv" 
                                onChange={(e) => setCsvFile(e.target.files[0])} 
                            />
                        </div>
                        <div stryle={{marginTop: '20px', textAlign: 'right'}}>
                            <Button
                                mt={"3"}
                                mr={"2"}
                                {...customStyles.button.primary}
                                onClick={downloadFile}
                            >
                                {t('DOWNLOAD_TEMPLATE')}
                            </Button>
                            <Button 
                                mt={"3"} 
                                float={"right"} 
                                {...customStyles.button.primary}
                                onClick={processBulkFinanceRecords}
                                isLoading={loading}
                                loadingText={`${t('PROCESSING')}...`}
                                isDisabled={loading || !csvFile}
                            >
                                {t('CREATE_FINANCE_RECORD')}
                            </Button>
                        </div>
                    </ModalBody>
                </ModalContent>
            </Modal>
        )
    }



    const renderCreateFinanceModal = () => {
        return(
            <Modal isOpen={isOpenFinanceModal} onClose={onCloseFinanceModal} size={'xl'}>
                <ModalOverlay />
                <ModalContent>
                    <ModalHeader style={{ backgroundColor: customStyles.modal.headerBg, color: customStyles.modal.headerColor }}>
                        {t('CREATE_FINANCE_RECORD')}
                    </ModalHeader>
                    <ModalCloseButton color="white" />
                    <ModalBody className="campina-modal-body">
                        <div className="form-group">
                            <label>{t('NAME')}</label>
                            <input 
                                type="text" 
                                className="form-control campina-input" 
                                value={financeName} 
                                onChange={(e) => setFinanceName(e.target.value)} 
                            />
                        </div>
                        <div className="form-group">
                            <label>{t('CATEGORY')}</label>
                            <Select
                                options={categorias.map((categoria) => {
                                    return {
                                        value: categoria.id,
                                        label: categoria.nombre,
                                    }
                                })}
                                onChange={(value) => setFinanceCategory(value)}
                                value={financeCategory}
                                styles={customStyles.select}
                            />
                        </div>
                        <div className="form-group">
                            <label>{t('DESCRIPTION')}</label>
                            <textarea className="form-control campina-textarea" value={financeDescription} onChange={(e) => setFinanceDescription(e.target.value)} />
                        </div>
                        <div className="form-group">
                            <Button 
                                mt={"3"} 
                                float={"right"} 
                                {...customStyles.button.primary}
                                onClick={requestCreateFinance}
                            >
                                {t('ADD')}
                            </Button>
                        </div>
                    </ModalBody>
                </ModalContent>
            </Modal>
        )
    }

    const renderModal = () => {
        return(
            <Modal isOpen={isOpenForm} onClose={onCloseForm} size={'xl'}>
                <ModalOverlay />
                <ModalContent>
                    <ModalHeader style={{ backgroundColor: customStyles.modal.headerBg, color: customStyles.modal.headerColor }}>
                        {t('ADD_FINANCE_RECORD')}
                    </ModalHeader>
                    <ModalCloseButton color="white" />
                    <ModalBody className="campina-modal-body">
                    <div className="form-group">
                        <label>{t('HOLDER')}</label>
                        <Select
                            onChange={(value) => setIdTitular(value)}
                            value={idTitular}
                            onInputChange={(value) => setSearchTitular(value)}
                            inputValue={searchTitular}
                            options={titulares}
                            onMenuScrollToBottom={() => {
                                if(pageTitular < totalPagesTitular){
                                    setPageTitular(pageTitular + 1);
                                }
                            }}
                            placeholder={`${t('SEARCH')}...`}
                            styles={customStyles.select}
                        />
                    </div>
                    <div className="form-group">
                        <label>{t('FINANCE_CATEGORY')}</label>
                        <Select
                            options={categorias.map((categoria) => {
                                return {
                                    value: categoria.id,
                                    label: categoria.nombre,
                                }
                            })}
                            onChange={(value) => setFinanceCategory(value)}
                            value={financeCategory}
                            placeholder={`${t('SEARCH')}...`}
                            styles={customStyles.select}
                        />
                    </div>
                    <div className="form-group">
                        <label>{t('AMOUNT')}</label>
                        <input type="number" className="form-control campina-input" value={monto} onChange={(e) => setMonto(e.target.value)} />
                    </div>
                    <div className="form-group">
                        <label>{t('DATE')}</label>
                        <input type="date" className="form-control campina-input" value={fecha} onChange={(e) => setFecha(e.target.value)} />
                    </div>
                    {/* <div className="form-group">
                        <Checkbox 
                            isChecked={global} 
                            onChange={(e) => setGlobal(false)} 
                            mt={"3"} 
                            colorScheme="orange"
                        >
                            {t('GLOBAL_CHECKBOX')}
                        </Checkbox>
                    </div> */}
                    <div className="form-group">
                        <Button 
                            mt={"3"} 
                            float={"right"} 
                            {...customStyles.button.primary}
                            onClick={requestCreateFinanceRecord}
                            isLoading={loading}
                            loadingText={`${t('ADDING')}...`}
                            isDisabled={loading}
                        >
                            {t('ADD')}
                        </Button>
                    </div>
                    </ModalBody>
                </ModalContent>
            </Modal>
        )
    }

    const renderDeleteModal = () => {
        return(
            <Modal isOpen={deleteReg ? true : false} onClose={() => setDeleteReg(null)}>
                <ModalOverlay />
                <ModalContent>
                    <ModalHeader style={{ backgroundColor: customStyles.modal.headerBg, color: customStyles.modal.headerColor }}>
                        {t('DELETE_RECORD')}
                    </ModalHeader>
                    <ModalCloseButton color="white" />
                    <ModalBody>
                        <div className="text-center">
                            <p>{t('DELETE_RECORD_CONFIRM')}</p>
                            <Button 
                                {...customStyles.button.danger} 
                                onClick={() => requestDeleteFinanzaRecord(deleteReg)}
                            >
                                {t('DELETE')}
                            </Button>
                            <Button
                                ml={"2"}
                                onClick={() => setDeleteReg(null)}
                            >
                                {t('CANCEL')}
                            </Button>
                        </div>
                    </ModalBody>
                </ModalContent>
            </Modal>
        )
    }

    return (
        <div className="cm-container campina-container">
            <div className="section-title">{t('FINANCE_MANAGEMENT')}</div>
            <div className="cm-button-container-right campina-content">
                {
                    renderModal()
                }
                {
                    renderCreateFinanceModal()
                }
                {
                    renderDeleteModal()
                }
                {
                    renderBulkModal()
                }
                <div className="filter-row">
                    <div className="date-filters">
                        <div className="form-group">
                            <label>{t('FROM')}</label>
                            <input 
                                type="date" 
                                className="form-control campina-input"
                                value={filterStartDate}
                                onChange={({ target }) => setFilterStartDate(target.value)}
                            />
                        </div>
                        <div className="form-group" style={{marginLeft: '10px'}}>
                            <label>{t('UNTIL')}</label>
                            <input 
                                type="date" 
                                className="form-control campina-input" 
                                value={filterEndDate}
                                onChange={({ target }) => setFilterEndDate(target.value)}
                            />
                        </div>
                        <Button 
                            mt={"6"} 
                            ml={"2"}
                            {...customStyles.button.primary}
                            onClick={() => {
                                setFilterStartDate('');
                                setFilterEndDate('');
                                setFilterByTitular(null);
                                setFilterByCategoria(null);
                            }}
                        >
                            {t('CLEAR_FILTERS')}
                        </Button>
                    </div>
                    <div className="filters-container">
                        <div className="form-group">
                            <label>{t('HOLDER')}</label>
                            <Select
                                onChange={(value) => setFilterByTitular(value)}
                                value={filterByTitular}
                                onInputChange={(value) => setSearchTitular(value)}
                                inputValue={searchTitular}
                                options={titulares}
                                onMenuScrollToBottom={() => {
                                    if(pageTitular < totalPagesTitular){
                                        setPageTitular(pageTitular + 1);
                                    }
                                }}
                                placeholder={`${t('SEARCH')}...`}
                                isClearable
                                styles={customStyles.select}
                            />
                        </div>
                        <div className="form-group" style={{marginLeft: '10px'}}>
                            <label>{t('CATEGORY')}</label>
                            <Select
                                options={categorias.map((categoria) => {
                                    return {
                                        value: categoria.id,
                                        label: categoria.nombre,
                                    }
                                })}
                                onChange={(value) => setFilterByCategoria(value)}
                                value={filterByCategoria}
                                isClearable
                                placeholder={`${t('SELECT_CATEGORY')}...`}
                                styles={customStyles.select}
                            />
                        </div>
                    </div>
                </div>
                <div className="search-row">
                    <div className="form-group">
                        <label>{t('SEARCH')}</label>
                        <input 
                            type="text" 
                            className="form-control campina-input" 
                            value={searchFinanzaRecord} 
                            onChange={({ target }) => setSearchFinanzaRecord(target.value)} 
                            placeholder={t('PLACEHOLDER_SEARCH')}
                        />
                    </div>
                </div>
                <div className="action-row">
                    <Button 
                        mt={"2"} 
                        mb={"2"}
                        {...customStyles.button.primary} 
                        onClick={onOpenBulkModal}
                    >
                        {t('BULK_FINANCE_RECORD')}
                    </Button>
                    <Button 
                        mt={"2"} 
                        mb={"2"}
                        {...customStyles.button.primary} 
                        onClick={onOpenForm}
                    >
                        + {t('ADD_RECORD')}
                    </Button>
                </div>
                <div className="table-container">
                    <TableContainer>
                        <Table variant="simple" className="campina-table">
                            <Thead>
                                <Tr>
                                    <Th className="campina-th">{t('MEMBER')}</Th>
                                    <Th className="campina-th">{t('CATEGORY')}</Th>
                                    <Th className="campina-th">{t('TYPE')}</Th>
                                    <Th className="campina-th">{t('AMOUNT')}</Th>
                                    <Th className="campina-th">{t('DATE')}</Th>
                                    <Th className="campina-th">{t('ACTIONS')}</Th>
                                </Tr>
                            </Thead>
                            <Tbody>
                                {
                                    finanzaRecords.map((finanzaRecord) => {
                                        return(
                                            <Tr key={finanzaRecord.id} className="campina-tr">
                                                <Th>{finanzaRecord.titular ? `${finanzaRecord.titular.nombre} ${finanzaRecord.titular.apellidos}` : t('GLOBAL_RECORD')}</Th>
                                                <Th>
                                                    {finanzaRecord.categoria ? finanzaRecord.categoria.nombre : 'N/A'}
                                                    {finanzaRecord.esAnualidad ? ` (${t('ANNUALITY')})` : ''}
                                                </Th>
                                                <Th>
                                                    {
                                                        finanzaRecord.categoria ? t(finanzaRecord.categoria.TipoMovimiento) : 'N/A'
                                                    }
                                                </Th>
                                                <Th>
                                                    {
                                                        finanzaRecord.monto ? formatToMXN(finanzaRecord.monto) : ''
                                                    }
                                                </Th>
                                                <Th>
                                                    {
                                                        finanzaRecord.fecha ? finanzaRecord.fecha.split('T')[0] : ''
                                                    }
                                                </Th>
                                                <Th>
                                                    <Button 
                                                        {...customStyles.button.danger} 
                                                        onClick={() => setDeleteReg(finanzaRecord.id)}
                                                        size="sm"
                                                    >
                                                        {t('DELETE')}
                                                    </Button>
                                                </Th>
                                            </Tr>
                                        )
                                    })
                                }
                            </Tbody>
                        </Table>
                    </TableContainer>
                </div>
                <div >
                    <Button
                        {...customStyles.button.primary}
                        onClick={downloadFinancialData}
                        isLoading={loadingCSV}
                        isDisabled={loadingCSV}
                        loadingText={`${t('DOWNLOADING')}...`}
                        mb={"4"}
                        mt={"4"}
                    >
                        {t('DOWNLOAD_FINANCIAL_DATA')}
                    </Button>
                </div>
                <div className="d-flex justify-content-center campina-pagination">
                    <Pagination
                        pageCount={totalPagesFinanzaRecord}
                        currentPage={pageFinanzaRecord}
                        onPageChange={(page) => setPageFinanzaRecord(page)}
                    />
                </div>
            </div>
        </div>
    );
}